export default {"src":"/_next/static/media/arrow-right-swiper.a27ba9e4.svg","height":21,"width":25,"blurWidth":0,"blurHeight":0};